import type { RefObject } from "react";
import { createContext } from "react";

type GiftCardContextProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  cardNumberInputRef: RefObject<HTMLInputElement | null>;
};

export const GiftCardContext = createContext<GiftCardContextProps | undefined>(
  undefined,
);
